<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>魅力值记录列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">会员编号：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入会员编号" style="width:400px;" v-model="subData.userId"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">操作值：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入操作值" style="width:400px;" v-model="subData.operationNum"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">最新值：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入最新值" style="width:400px;" v-model="subData.nowNum"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">操作时间：</el-text>
			<el-col :span="4">
				<el-date-picker v-model="subData.addDate" type="date" placeholder="选择日期"></el-date-picker>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">备注：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入备注" style="width:400px;" v-model="subData.remark"></el-input>
			</el-col>
		</el-row>

      <el-row class="bt" style="padding:15px 0; padding-left: 100px;">
        <el-button type="primary" @click="submitEvent">确定</el-button>
        <el-button plain type="primary" @click="backEvent">返回</el-button>
      </el-row>
    </el-card>
  </div>
</template>

  
<script>

export default {
  data() {
    return {
      id: this.$route.query.id?this.$route.query.id:0,
      subData:{
		userId : '',
		operationNum : '',
		nowNum : '',
		addDate : '',
		remark : '',

      }
    }
  },
  mounted:function(){
    if(this.id>0){
      this.getData()
    }
  },
  methods: {
    backEvent(){
        this.$router.go(-1)
    },
    getData(){
      var ths = this
      ths.$get('/MeiliLogs/queryById?id='+ths.id)
      .then(function (res) { 
          if(res.success){
            ths.subData = res.data
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    submitEvent() {
      const ths = this;

      ths.$post('/MeiliLogs/edit?', ths.subData)
        .then(function (res) { 
            alert(res.msg)
            if(res.success){
              ths.$router.push("/Admin/MeiliLogsList")
            }
        })
        .catch(function (err) {
          console.log(err)
        })      
      },
   }
}

</script>

<style>
.form-row{
  padding:15px 0; 
}
</style>